import React from 'react';
import {
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Typography
} from '@mui/material';

const CardMaterial = ({heading,content,img,github,deploy,k,techStacks}) => {
  return (
    <div style={{marginTop:"20px"}} className='img-scale' key={k}>
      <Card sx={{maxWidth:'345'}}>
        <CardMedia 
          component='img'
          alt='Project image'
          image={img}
          height={150}
        />
        <CardContent>
          <Typography
            variant='h5'
            compenent='div'
          >
            {heading}
          </Typography>
          <Typography 
            variant='body2'
            color='text.secondary'
          >
            {content}
          </Typography>
          <Typography sx={{
            display:"flex",
            gap:"1em"
          }}>
            <p>TECH STACK: </p>
            <p>{techStacks && techStacks.join(", ")}</p>
          </Typography>
        </CardContent>
        <CardActions>
          {deploy && <Button variant='contained'  ><a style={{textDecoration:'none',color:'white'}} href={deploy ? deploy : ""} target='_blank' rel='noreferrer'>Live deploy</a></Button>}
          <Button variant='contained' ><a style={{textDecoration:'none',color:'white'}} href={github} target='_blank' rel='noreferrer'>Github</a></Button>
        </CardActions>
      </Card>
    </div>
  )
}

export default CardMaterial;